// extracted by mini-css-extract-plugin
export default {"VoiceCardDot":"Sqi2Ogq8UIY6SDLVi_u9","voiceCardDot":"Sqi2Ogq8UIY6SDLVi_u9","active":"uJSfk_UC_voU7E3ZQQo6"};